import { overviewStats, topKeywords } from "@/mocks/evaluations";

const ratioBars = [
  { label: "好评 · 真性情支持", pct: overviewStats.positive, cls: "bg-primary-500" },
  { label: "中立 · 围观吃瓜", pct: overviewStats.neutral, cls: "bg-accent-500", highlight: true },
  { label: "差评 · 观感不佳", pct: overviewStats.negative, cls: "bg-secondary-500" },
];

export default function Overview() {
  return (
    <section id="overview" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        {/* left ratio panel */}
        <div>
          <p className="font-bebas text-sm tracking-[0.2em] text-primary-500">PUBLIC SENTIMENT</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            风评总览 · <span className="text-primary-500">好差口碑构成</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            基于近期全网讨论样本的简化估算，看大众对哇偶姐姐的评价构成与争议分布。
          </p>

          <div className="mt-7 flex items-end gap-4">
            <span className="font-heading text-5xl font-black text-foreground-950">
              <span className="font-bebas text-accent-500">{overviewStats.neutral}</span>%
            </span>
            <div className="pb-1.5">
              <p className="text-sm font-semibold text-foreground-900">中立围观占比最高</p>
              <p className="text-xs text-foreground-600">吃瓜路人仍是最大声量群体</p>
            </div>
          </div>

          <div className="mt-7 space-y-5">
            {ratioBars.map((b) => (
              <div key={b.label}>
                <div className="flex items-center justify-between">
                  <p className={`text-sm ${b.highlight ? "font-semibold text-foreground-900" : "text-foreground-700"}`}>
                    {b.label}
                  </p>
                  <span className={`font-bebas text-xl ${b.highlight ? "text-accent-600" : "text-foreground-700"}`}>
                    {b.pct}%
                  </span>
                </div>
                <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className={`h-full rounded-full ${b.cls}`} style={{ width: `${b.pct}%` }} />
                </div>
              </div>
            ))}
          </div>

          <p className="mt-6 rounded-lg bg-background-100 p-4 text-xs leading-5 text-foreground-600">
            <i className="ri-megaphone-line mr-1 text-accent-500" aria-hidden="true" />
            {overviewStats.hotNote}
          </p>
        </div>

        {/* right keyword panel */}
        <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-7">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-lg font-bold text-foreground-950">讨论关键词热词</h3>
            <span className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600">
              样本 {overviewStats.totalSamples} 条
            </span>
          </div>
          <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-timer-line text-primary-500" aria-hidden="true" />
            词频越高代表讨论越集中，越可能导向定论
          </div>

          <div className="mt-5 flex flex-wrap gap-2.5">
            {topKeywords.map((k, idx) => (
              <span
                key={k.word}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-sm ${
                  idx < 2
                    ? "bg-primary-500 font-medium text-background-50"
                    : idx < 4
                      ? "bg-accent-100 text-accent-900"
                      : "bg-background-200 text-foreground-700"
                }`}
              >
                {k.word}
                <span className={`text-xs ${idx < 2 ? "text-background-100" : "text-foreground-500"}`}>{k.count}</span>
              </span>
            ))}
          </div>

          <div className="mt-8 rounded-xl bg-background-50 p-5">
            <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-zoom-in-line" aria-hidden="true" />
              </span>
              一句话看懂当前风评
            </p>
            <p className="mt-3 text-[15px] leading-7 text-foreground-700">
              哇偶姐姐的热度仍未散场，正面欣赏其「敢说」的真性情、负面聚焦其「人设与商业吃相」，
              大量路人则在围观中等待一个能服众的后续回应。舆论尚未一边倒，仍处在多空博弈阶段。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}